import { PdfGen } from '../pdf/pdf';
import { OptsLabel } from './optsLabel';

export const ILayoutLabelSymbol = Symbol('LayoutLabel');

export interface ILayoutLabelGen {
  generate(pdf: PdfGen, opts: OptsLabel): Promise<void>;
}
